// Handle filter changes
$('body').on('change', '.form-check-input', function () {
    updateFiltersAndFetch();
});

// Function to get selected filters and update the URL
function updateFiltersAndFetch() {
    const selectedFilters = [];

    $('.form-check-input:checked').each(function () {
        const filterType = $(this).closest('.accordion-item').find('.item-header').attr('id');
        selectedFilters.push(`${encodeURIComponent(filterType)}=${encodeURIComponent($(this).val())}`);
    });
    // selectedFilters.push(`${encodeURIComponent('page')}=${$('.pagination-container').data('current-page')}`);
    var selectedFiltersAjax = [...selectedFilters];
    selectedFiltersAjax.push(`${encodeURIComponent('category')}=${$('.search-results').data('cid')}`);
    const params = selectedFilters.join('&');
    const url = `${window.location.pathname}?${params}`;
    const urlAjax = `${'/Search-ShowAjax'}?${selectedFiltersAjax.join('&')}`;
    history.pushState(null, '', url);
    fetchProducts(urlAjax);
}
// Update the product list on the page
function updateProductList(data) {
    $('.search-results .product-grid').html(data.updateGridHtml);
    $('.js-filter-sidebar .sidebar-body').html(data.newRefinementsHtml);
    $('img.img-loading').each(function() {
        let $img = $(this);
        function removeLoadingEffect() {
            $img.removeClass('img-loading');
        }

        if ($img[0].complete && $img[0].naturalWidth !== 0) {
            removeLoadingEffect();
        } else {
            $img.one('load', removeLoadingEffect).one('error', removeLoadingEffect);
        }
    });
}
// Fetch products from the server
function fetchProducts(url) {
    $.spinner().start();
    $.ajax({
        url: url,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            updateProductList(data);
            $.spinner().stop();
        },
        error: function (err) {
            console.error('Error fetching products:', err);
            $.spinner().stop();
        }
    });
}

$('body').on('click','.page-btn', function () {
    const page = $(this).data('page');
    const baseUrl = $('.pagination-container').data('url');
    const urlAjax = new URL(baseUrl, window.location.origin);
    const currentUrl = window.location.href;
    var url = new URL(currentUrl);
    url.searchParams.set('page', page);
    url = url.toString();
    urlAjax.searchParams.set('page', page);
    history.pushState(null, '', url);
    fetchProducts(urlAjax);
});

$('body').on('click','.menu.search', function () {
    $('body').addClass('show-search')
});
$('body').on('click','.main-search__close', function () {
    $('body').removeClass('show-search')
});